// Creates a Date object with specified value for given type
export function createDate(value, type) {
    const date = new Date(2000, 0, 1);
    if (type === 'month')
        date.setMonth(value - 1);
    if (type === 'day')
        date.setDate(value);
    if (type === 'year')
        date.setFullYear(value);
    return date;
}
// Formats value using browser's locale settings
export function formatWithLocale(value, type, locale) {
    const formatter = new Intl.DateTimeFormat(locale, {
        [type]: type === 'year' ? 'numeric' : '2-digit',
    });
    const date = createDate(value, type);
    const parts = formatter.formatToParts(date);
    const part = parts.find(p => p.type === type);
    return (part === null || part === void 0 ? void 0 : part.value) || value.toString();
}
// Gets placeholder from locale
export function getPlaceholderFromLocale(type, locale) {
    const formatter = new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    // Create a date with all parts set to 1
    const date = new Date(2000, 0, 1);
    const parts = formatter.formatToParts(date);
    // Find the part we're interested in
    const part = parts.find(p => (type === 'month' && p.type === 'month') ||
        (type === 'day' && p.type === 'day') ||
        (type === 'year' && p.type === 'year'));
    // Use the actual format from the locale
    const length = (part === null || part === void 0 ? void 0 : part.value.length) || 2;
    return type === 'year'
        ? 'y'.repeat(length)
        : type === 'month'
            ? 'm'.repeat(length)
            : 'd'.repeat(length);
}
// Main method for formatting date values
export function formatDateValue(value, type, locale) {
    // If value is null or empty string, return placeholder
    if (value === null || value === '') {
        const placeholder = getPlaceholderFromLocale(type, locale);
        return placeholder;
    }
    // If value is a string (like 'mm', 'dd', 'yyyy'), return as is
    if (typeof value === 'string' && !/^\d+$/.test(value)) {
        return value;
    }
    return formatWithLocale(Number(value), type, locale);
}
// Gets the date format parts and separators from locale
export function getLocaleFormatInfo(locale) {
    const formatter = new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    const date = new Date(2000, 0, 1);
    const parts = formatter.formatToParts(date);
    // Get the order of parts and separators
    return parts.map(part => ({
        type: part.type,
        value: part.value,
    }));
}
// Gets the field order based on locale
export function getFieldOrder(locale) {
    const formatInfo = getLocaleFormatInfo(locale);
    return formatInfo
        .filter(part => part.type !== 'literal')
        .map(part => part.type);
}
